import { ErrorMessage, Field } from 'formik'

export function FormTextarea({
  name,
  label,
  placeholder,
  required = false,
  rows = 4,
  className = '',
  showLabel = true,
  ...props
}) {
  return (
    <div className="w-full">
      {showLabel && (
        <label
          htmlFor={name}
          className="block text-left font-sans text-xs font-medium uppercase tracking-widest text-muted-foreground mb-2"
        >
          {label}
        </label>
      )}
      <Field name={name}>
        {({ field, meta }) => (
          <>
            <textarea
              {...field}
              {...props}
              id={name}
              rows={rows}
              placeholder={placeholder}
              required={required}
              className={`w-full min-w-0 border-2 border-foreground/20 bg-card px-4 py-3 text-base text-foreground font-serif placeholder:text-muted-foreground/60 transition-all focus:outline-none focus:border-foreground focus:bg-background resize-y ${
                meta.touched && meta.error
                  ? 'border-destructive focus:border-destructive'
                  : ''
              } ${className}`}
            />
            <ErrorMessage
              name={name}
              component="div"
              className="mt-2 text-sm text-destructive font-sans"
            />
          </>
        )}
      </Field>
    </div>
  )
}
